import React from 'react';
import { css } from '@emotion/react';
// import { css } from '@emotion/react';
import ClipLoader from 'react-spinners/ClipLoader';
import PropTypes from 'prop-types';
// 使用react-spinners做loading效果 https://www.npmjs.com/package/react-spinners
const maskCss = {
'background': 'rgba(0, 0, 0, 0.6)',
'top': 0,
'left': 0,
'zIndex': 9999,
};

const override = css`
display: block;
margin: -73px auto 0 -100px;
position: absolute;
top: 50%;
left: 50%;
`;


const LoadingEffect = ({
  // state
  isLoading,
}) => (
  !isLoading ? null
    : (
      <div className="modal-mask d-flex position-fixed w-100 h-100" id="loading_wrap" style={maskCss}>
        <ClipLoader loading={isLoading} css={override} size={150} />
      </div>
    )
);

export default LoadingEffect;

LoadingEffect.propTypes = {
  isLoading: PropTypes.bool.isRequired,
};
